import React from "react";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import styled, { withTheme } from "styled-components";
import PropTypes from "prop-types";

class AlertDialog extends React.Component {
  state = {
    open: true
  };

  handleActivity = () => {
    const { onRightBtnClick } = this.props;
    onRightBtnClick();
    this.handleClose();
  };

  handleClose = () => {
    const { showAlert } = this.props;
    showAlert();
    this.setState({ open: false });
  };

  render() {
    const { open } = this.state;
    const { text, btnLeftText, btnRightText } = this.props;
    return (
      <div>
        <Dialog
          open={open}
          onClose={this.handleClose}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DialogTitle id="alert-dialog-title" />
          <DialogContent>
            <DialogContentText id="alert-dialog-description">
              {text}
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button onClick={this.handleClose} color="primary">
              {btnLeftText}
            </Button>
            <Button onClick={this.handleActivity} color="primary" autoFocus>
              {btnRightText}
            </Button>
          </DialogActions>
        </Dialog>
      </div>
    );
  }
}

AlertDialog.propTypes = {
  text: PropTypes.string,
  btnLeftText: PropTypes.string,
  btnRightText: PropTypes.string,
  onRightBtnClick: PropTypes.func,
  showAlert: PropTypes.func
};

AlertDialog.defaultProps = {
  text: "Are you sure?",
  btnLeftText: "Cancel",
  btnRightText: "Agree",
  onRightBtnClick: () => {},
  showAlert: () => {}
};

export const Alert = styled(withTheme(AlertDialog))``;
